import { useState, useEffect } from 'react';
import { basePort, getUsernameJwt, headers, getRoleJwt, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies } from "../../module_auth/AuthService"
import React, { Component } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../common/Toast"

import ReactQuill from 'react-quill';
import QuillResizeImage from 'quill-resize-image';
import Quill from "quill";
import 'react-quill/dist/quill.snow.css';
Quill.register("modules/resize", QuillResizeImage); 

export function CmtyBaseRegPost() {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [mbrId, setMbrId] = useState("");

    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");

    const [cmtyCatg, setCmtyCatg] = useState(localStorage.getItem("CTMY_CATG"));
    const [cmtyCatgName, setCmtyCatgName] = useState(localStorage.getItem("CTMY_CATG_NAME"));
    const [cmtyCatgUrl, setCmtyCatgUrl] = useState(localStorage.getItem("CTMY_CATG_URL"));
    
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies())
            || getRoleJwt(getJwtFromCookies()) != "ROLE_PV"){
            moveTo()
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
        }
    }, []);

    function clickSubmit(event) {
        event.preventDefault();
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/post/cmty', 
            {method:'post', headers,
                        body:JSON.stringify({
                        title:title,
                        content:content,
                        catg:cmtyCatg
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function moveTo() {
        setRedirect(true)
        setRedirectUrl(cmtyCatgUrl+"?page=1")
    }

    function handleTitle(event) {
        setTitle(event.target.value);
    }

    const handleImage = () => {
        const MAX_FILE_SIZE = 2; // 2MB limit
        //console.log("content" + content)
        const images = document.querySelectorAll('img'); // Select all <img> tags
        const base64Strings = [];

        images.forEach((img) => {
            const src = img.src;
            // Check if the src contains a Base64 string
            if (src.startsWith("data:image")) {
                const base64 = src.split(',')[1]; // Get the part after the comma
                base64Strings.push(base64); // Store Base64 string
                // Calculate the size of the Base64 string in bytes
                const base64Length = base64.length;

                // Calculate the size of the original image (approximate)
                const originalSizeBytes = (base64Length * 3) / 4;

                // Convert to MB
                const sizeInMB = originalSizeBytes / (1024 * 1024);
                //console.log("sizeInMB-" + sizeInMB)
                if (sizeInMB > MAX_FILE_SIZE) {
                    img.remove();
                    alert("파일 크기가 2MB를 초과해요. 더 작은 이미지를 업로드해 주세요!");
                    return;
                }
            }
        });
    };

    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>커뮤니티</span></li>
                        <li class="breadcrumb-item"><span>{cmtyCatgName}</span></li>
                        <li class="breadcrumb-item"><span>글쓰기</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" onChange={handleTitle}/>
                    </form>
                    <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                        <label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>내용</label>
                        <div class="container" style={{height:'400px', marginBottom:'10px'}}>
                        <ReactQuill theme="snow" value={content} onChange={setContent}
                            style={{height: '300px', marginBottom:'10px', resize: 'vertical', resize: 'vertical'}}
                            modules={{
                                toolbar: {
                                    container: [
                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                        [{ size: [] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ 'align': [] }],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['image'],
                                        ['clean'],
                                        ['code-block']
                                    ],
                                    handlers: {
                                        image: handleImage(),
                                    },
                                },
                                resize: {
                                    locale: {},
                                },
                            }}
                        />
                        </div>
                    </form>
                    <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}>
                        <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickSubmit}>등록하기</button>
                    </form>
                    <ToastMessage show={showToast} msg={msgToast}/>
                    </div>
                </section>
            </main>
        </div>
    );
}